import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ModalOne } from 'components/core';

interface ConfirmDialogProps {
  show: boolean;
  title: string;
  message: string;
  /** Names the action, e.g. "Remove"; falls back to a plain "Confirm". */
  confirmLabel?: string;
  onConfirm: (event: React.SyntheticEvent) => void;
  onCancel: () => void;
}

/** Asks before something is thrown away or taken away from someone. Cancel, the close button and nothing else leave it untouched. */
export const ConfirmDialog = ({ show, title, message, confirmLabel, onConfirm, onCancel }: ConfirmDialogProps) => {
  const { t } = useTranslation();
  if (!show) return null;
  // Rendered on the page body, not where it is used: inside a form its buttons would submit that form.
  return createPortal(
    <ModalOne
      modalLabel="confirmRemoval"
      modalTitle={title}
      btnTextPrimary={confirmLabel ?? t('ACTION.CONFIRM')}
      primaryBtnHandler={onConfirm}
      secondaryBtnHandler={onCancel}
      renderLeft={<p className="mb-0" role="alertdialog" aria-label={title}>{message}</p>}
      showModal
    />,
    document.body
  );
};
